"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.loadLargeSet = loadLargeSet;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/entries"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _url = _interopRequireDefault(require("url"));

var _listings = require("./modules/listings");

var _members = require("./modules/members");

var _suburbs = require("./modules/suburbs");

var _organisations = require("./modules/organisations");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context13; (0, _forEach.default)(_context13 = ownKeys(Object(source), true)).call(_context13, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context14; (0, _forEach.default)(_context14 = ownKeys(Object(source))).call(_context14, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

// Maximum number of retries before giving up
var MAX_RETRIES = 5; // Backoff size in ms for retries; stepped exponentially, e.g. 50, 100, 200, 400, 800

var RETRY_STEP = 50;
var nullables = {
  public: true,
  statusCode: true,
  listingStateCode: true
};
/**
 * Performs the minimal transformation that is required to ensure
 * that a query object will be accepted by the Listings Api. This
 * now only requires that `null` params are stipped.
 *
 * Note that this isn't a great approach; `null` is a valid value for the public
 * field (at least) and may be for others.  We need to stop setting any nulls
 * (if we are) that we don't want instead.
 *
 * @param {Object} the query object
 *
 * @return {Object} the transformed query object
 */

var transformQuery = function transformQuery(params) {
  var _context;

  return (0, _reduce.default)(_context = (0, _keys.default)(params)).call(_context, function (previous, k) {
    // Ignore the debug note
    if (k === '__debug') return previous;
    if (params[k] === undefined || params[k] === null && !nullables[k]) return previous;
    previous[k] = params[k]; // eslint-disable-line no-param-reassign

    return previous;
  }, {});
};
/**
 * Node fetch is currently incompatible with the spec but provides another
 * method to grab headers.  This can be removed once the 2.0.0 branch comes
 * out which is more spec compliant.
 */


function extractHeaders(response) {
  var _context2;

  if (!response.headers) return response.headers;
  if (response.headers.raw) return response.headers.raw();
  if ((0, _entries.default)(response.headers)) return (0, _toConsumableArray2.default)((0, _entries.default)(_context2 = response.headers).call(_context2));
  return response.headers;
}
/**
 * Assert that a response was OK; if not, log it and throw an Error to abort
 * the promise that this is run within.
 */


var assertOKResponse = function assertOKResponse(res, body, search, rawSearch, sent, logger) {
  if (res.ok) {
    return;
  }

  var status = body.status,
      message = body.message,
      _body$_additionalInfo = body._additionalInformation,
      _additionalInformation = _body$_additionalInfo === void 0 ? {} : _body$_additionalInfo;

  var error = new Error("Search failed: ".concat(message || res.statusText));
  error.code = res.status;
  error.__handled = true;
  error.__retry = false;

  if (logger) {
    logger.error("Search failed: ".concat(message || res.statusText), {
      httpStatus: res.status,
      status,
      search,
      rawSearch,
      _additionalInformation,
      error,
      sent,
      headers: extractHeaders(res),
      body
    });
  }

  throw error;
};
/**
 * Standardizes the data returned from a successful Api call.
 *
 * @param {Object} the parsed response body
 *
 * @return {Object} and object containing listings and totalResults
 */


var cleanResponse = function cleanResponse(_ref) {
  var _ref$hits = _ref.hits,
      hits = _ref$hits === void 0 ? 0 : _ref$hits,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data;
  return {
    totalResults: hits,
    data
  };
}; // Get the last "sort" entry for paging large results


var getNextPageAfter = function getNextPageAfter(data) {
  return data.length ? (0, _slice.default)(data).call(data, -1)[0].sorts : undefined;
};

var cleanListings = function cleanListings(_ref2) {
  var totalResults = _ref2.totalResults,
      data = _ref2.data;
  return {
    totalResults,
    results: (0, _map.default)(data).call(data, function (_ref3) {
      var value = _ref3.value;
      return (0, _listings.mapListing)(value);
    }),
    nextPageAfter: getNextPageAfter(data)
  };
};

var cleanSuburbs = function cleanSuburbs(_ref4) {
  var totalResults = _ref4.totalResults,
      data = _ref4.data;
  return {
    totalResults,
    results: (0, _map.default)(data).call(data, function (_ref5) {
      var value = _ref5.value;
      return (0, _suburbs.mapSuburb)(value);
    }),
    nextPageAfter: getNextPageAfter(data)
  };
};

var cleanMembers = function cleanMembers(_ref6) {
  var totalResults = _ref6.totalResults,
      data = _ref6.data;
  return {
    totalResults,
    results: (0, _map.default)(data).call(data, function (_ref7) {
      var value = _ref7.value;
      return (0, _members.mapMember)(value);
    }),
    nextPageAfter: getNextPageAfter(data)
  };
};

var cleanOrganisations = function cleanOrganisations(_ref8) {
  var totalResults = _ref8.totalResults,
      data = _ref8.data;
  return {
    totalResults,
    results: (0, _map.default)(data).call(data, function (_ref9) {
      var value = _ref9.value;
      return (0, _organisations.mapOrganisation)(value);
    }),
    nextPageAfter: getNextPageAfter(data)
  };
};

var delay = function delay(attempt, handler) {
  return new _promise.default(function (resolve, reject) {
    (0, _setTimeout2.default)(function () {
      try {
        var result = handler();

        if (result.then) {
          result.then(resolve).catch(reject);
        } else {
          resolve(result);
        }
      } catch (e) {
        reject(e);
      }
    }, RETRY_STEP * (Math.pow(2, attempt) - 1));
  });
};
/**
 * Sends a request in the same format as required by the real upstream
 * Api, as a POST with a JSON body.
 */


function sendStandardRequest(fetch, endpoint, key, params) {
  var headers = {
    'X-ApiKey': key,
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }; // Add key as a query string parameter too

  var parsed = _url.default.parse(endpoint, true);

  var _endpoint = _url.default.format(_objectSpread(_objectSpread({}, parsed), {}, {
    search: '',
    query: _objectSpread(_objectSpread({}, parsed.query), {}, {
      // Make a genuinely missing Api key obvious
      apiKey: key || 'MISSING_Api_KEY'
    })
  }));

  return fetch(_endpoint, {
    method: 'POST',
    headers,
    body: (0, _stringify.default)(params)
  }).then(function (res) {
    return [res, {
      method: 'POST',
      headers,
      endpoint,
      body: params
    }];
  });
}
/**
 * Generic handler for querying an Api endpoint.
 */


var queryApi = function queryApi(fetch, logger, endpoint, key, params) {
  var send = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : sendStandardRequest;
  var cleaner = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : cleanResponse;
  var attempt = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;

  var _params = transformQuery(params);

  _params.size = _params.size === undefined ? 1000 : _params.size;
  return send(fetch, endpoint, key, _params).then(function (_ref10) {
    var _ref11 = (0, _slicedToArray2.default)(_ref10, 2),
        res = _ref11[0],
        sent = _ref11[1];

    // Confirm that JSON was sent
    var _split = (res.headers.get('content-type') || '').split(/\s*;\s*/),
        _split2 = (0, _slicedToArray2.default)(_split, 1),
        contentType = _split2[0];

    if (typeof res.json !== 'function' || contentType !== 'application/json') {
      // Get the text if possible, otherwise just log the whole value
      return _promise.default.resolve(typeof res.text === 'function' ? res.text() : undefined).then(function (value) {
        var _context3;

        var error = new Error((0, _concat.default)(_context3 = "DataClient Non-JSON response (HTTP ".concat(res.status, " ")).call(_context3, res.statusText, ")"));
        error.body = value;
        error.params = _params;
        error.headers = extractHeaders(res);
        error.sent = sent;
        throw error;
      });
    } // Note: res.text should always be present, but sometimes is not...


    return _promise.default.resolve(typeof res.text === 'function' ? res.text() : res.text).then(function (text) {
      var data;

      try {
        data = JSON.parse(text);
        assertOKResponse(res, data, _params, params, sent, logger);
        return cleaner ? cleaner(data) : data;
      } catch (error) {
        var _context4, _context5;

        // Failed parsing JSON, log details for analysis
        var _err = new Error((0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "Bad Api response (HTTP ".concat(res.status, " ")).call(_context5, res.statusText, "): ")).call(_context4, error.message));

        _err.body = data || text;
        _err.headers = extractHeaders(res);
        _err.params = _params;
        _err.error = error;
        _err.sent = sent;
        _err.__retry = error.__retry;
        throw _err;
      }
    });
  }).catch(function (error) {
    var willRetry = error.__retry !== false && attempt < MAX_RETRIES; // Log errors lower if we're going to retry

    var level = willRetry ? 'warn' : 'error';

    if (!error.__handled && logger) {
      var _context6, _context7;

      // Log the error if not already handled
      logger.log(level, (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "Failed Api call #".concat(attempt, " to ")).call(_context7, endpoint, ": ")).call(_context6, error.message), {
        error
      });
    }

    if (willRetry) {
      // Retry the attempt
      return delay(attempt, function () {
        return queryApi(fetch, logger, endpoint, key, params, send, cleaner, attempt + 1);
      });
    }

    throw error;
  });
};

var parseRawResponse = function parseRawResponse(fn) {
  return function (body) {
    var data = JSON.parse(body.data);
    return fn ? fn(data) : data;
  };
};

var cleanRawResponse = function cleanRawResponse(data) {
  var aggregations = data.aggregations,
      _data$hits = data.hits,
      hits = _data$hits.hits,
      total = _data$hits.total;
  return {
    aggregations: aggregations,
    totalResults: total,
    // Converts hits from raw responses to same structure as API responses
    data: (0, _map.default)(hits).call(hits, function (h) {
      return {
        value: h._source,
        sorts: []
      };
    })
  };
};

var queryRawApi = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fetch, logger, endpoint, key, params, send, cleaner) {
    var res;
    return _regenerator.default.wrap(function _callee$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return queryApi(fetch, logger, "".concat(endpoint, "/_raw?rawResponse=true"), key, params, send, null);

          case 2:
            res = _context8.sent;
            return _context8.abrupt("return", parseRawResponse(cleaner)(res));

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee);
  }));

  return function queryRawApi(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref12.apply(this, arguments);
  };
}();
/**
 * Fetches data from the RW Listings Api.
 *
 * @param {Object} the query paramaters
 *
 * @returns {Promise} the results of the Api call
 */


var queryListingApi = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(fetch, logger, endpoint, key, params, send, raw) {
    var args, res;
    return _regenerator.default.wrap(function _callee2$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            args = [fetch, logger, "".concat(endpoint, "listings"), key, _objectSpread({
              size: 10
            }, params), send];

            if (raw) {
              _context9.next = 7;
              break;
            }

            _context9.t0 = cleanListings;
            _context9.next = 5;
            return queryApi.apply(void 0, args);

          case 5:
            _context9.t1 = _context9.sent;
            return _context9.abrupt("return", (0, _context9.t0)(_context9.t1));

          case 7:
            _context9.t2 = cleanRawResponse;
            _context9.next = 10;
            return queryRawApi.apply(void 0, (0, _concat.default)(args).call(args, [null]));

          case 10:
            _context9.t3 = _context9.sent;
            res = (0, _context9.t2)(_context9.t3);
            return _context9.abrupt("return", _objectSpread({
              aggregations: res.aggregations
            }, cleanListings(res)));

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee2);
  }));

  return function queryListingApi(_x8, _x9, _x10, _x11, _x12, _x13, _x14) {
    return _ref13.apply(this, arguments);
  };
}();
/**
 * Fetches data from the RW Suburbs Api.
 *
 * @param {Object} the query paramaters
 *
 * @returns {Promise} the results of the Api call
 */


var querySuburbApi = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(fetch, logger, endpoint, key, params, send, raw) {
    var args, res;
    return _regenerator.default.wrap(function _callee3$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            args = [fetch, logger, "".concat(endpoint, "suburbs"), key, _objectSpread({
              size: 1000
            }, params), send];

            if (raw) {
              _context10.next = 7;
              break;
            }

            _context10.t0 = cleanSuburbs;
            _context10.next = 5;
            return queryApi.apply(void 0, args);

          case 5:
            _context10.t1 = _context10.sent;
            return _context10.abrupt("return", (0, _context10.t0)(_context10.t1));

          case 7:
            _context10.t2 = cleanRawResponse;
            _context10.next = 10;
            return queryRawApi.apply(void 0, (0, _concat.default)(args).call(args, [null]));

          case 10:
            _context10.t3 = _context10.sent;
            res = (0, _context10.t2)(_context10.t3);
            return _context10.abrupt("return", _objectSpread({
              aggregations: res.aggregations
            }, cleanSuburbs(res)));

          case 13:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee3);
  }));

  return function querySuburbApi(_x15, _x16, _x17, _x18, _x19, _x20, _x21) {
    return _ref14.apply(this, arguments);
  };
}();
/**
 * Fetches data from the RW Members Api.
 *
 * @param {Object} the query paramaters
 *
 * @returns {Promise} the results of the Api call
 */


var queryMemberApi = /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(fetch, logger, endpoint, key, params, send, raw) {
    var args, res;
    return _regenerator.default.wrap(function _callee4$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            args = [fetch, logger, "".concat(endpoint, "members"), key, _objectSpread({
              size: 1000
            }, params), send];

            if (raw) {
              _context11.next = 7;
              break;
            }

            _context11.t0 = cleanMembers;
            _context11.next = 5;
            return queryApi.apply(void 0, args);

          case 5:
            _context11.t1 = _context11.sent;
            return _context11.abrupt("return", (0, _context11.t0)(_context11.t1));

          case 7:
            _context11.t2 = cleanRawResponse;
            _context11.next = 10;
            return queryRawApi.apply(void 0, (0, _concat.default)(args).call(args, [null]));

          case 10:
            _context11.t3 = _context11.sent;
            res = (0, _context11.t2)(_context11.t3);
            return _context11.abrupt("return", _objectSpread({
              aggregations: res.aggregations
            }, cleanMembers(res)));

          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee4);
  }));

  return function queryMemberApi(_x22, _x23, _x24, _x25, _x26, _x27, _x28) {
    return _ref15.apply(this, arguments);
  };
}();
/**
 * Fetches data from the RW Organisations Api.
 *
 * @param {Object} the query paramaters
 *
 * @returns {Promise} the results of the Api call
 */


var queryOrganisationApi = /*#__PURE__*/function () {
  var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(fetch, logger, endpoint, key, params, send, raw) {
    var args, res;
    return _regenerator.default.wrap(function _callee5$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            args = [fetch, logger, "".concat(endpoint, "organisations"), key, _objectSpread({
              size: 1000
            }, params), send];

            if (raw) {
              _context12.next = 7;
              break;
            }

            _context12.t0 = cleanOrganisations;
            _context12.next = 5;
            return queryApi.apply(void 0, args);

          case 5:
            _context12.t1 = _context12.sent;
            return _context12.abrupt("return", (0, _context12.t0)(_context12.t1));

          case 7:
            _context12.t2 = cleanRawResponse;
            _context12.next = 10;
            return queryRawApi.apply(void 0, (0, _concat.default)(args).call(args, [null]));

          case 10:
            _context12.t3 = _context12.sent;
            res = (0, _context12.t2)(_context12.t3);
            return _context12.abrupt("return", _objectSpread({
              aggregations: res.aggregations
            }, cleanOrganisations(res)));

          case 13:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee5);
  }));

  return function queryOrganisationApi(_x29, _x30, _x31, _x32, _x33, _x34, _x35) {
    return _ref16.apply(this, arguments);
  };
}();
/**
 * Executes an ElasticSearch DSL query against ES, proxied
 * through the listings Api.
 *
 * @param {Array} ids A list of organisation IDs to gather metadata for.
 *
 * @returns {Promise} the results of the call
 */


var queryOrganisationMetadataApi = function queryOrganisationMetadataApi(fetch, logger, endpoint, key, send, stepSize, ids) {
  return queryRawApi(fetch, logger, "".concat(endpoint, "listings"), key, (0, _organisations.organisationMetadataDSL)(stepSize, ids), send, _organisations.cleanOrganisationMetadata);
};

var queryAgentMetadataApi = function queryAgentMetadataApi(fetch, logger, endpoint, key, send, agentId, orgIds, allowOtherTransactions) {
  return queryRawApi(fetch, logger, "".concat(endpoint, "listings"), key, (0, _organisations.agentMetadataDSL)(agentId, orgIds, allowOtherTransactions), send, _members.cleanAgentMetadata);
};
/**
 * Gets a unified client with appropriate parameters bound for simple use.
 */


var getClient = function getClient(fetch, logger, endpoint, key) {
  var send = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : sendStandardRequest;

  var getListings = function getListings(params) {
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return queryListingApi(fetch, logger, endpoint, key, params, send, raw);
  };

  var getSuburbs = function getSuburbs(params) {
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return querySuburbApi(fetch, logger, endpoint, key, params, send, raw);
  };

  var getMembers = function getMembers(params) {
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return queryMemberApi(fetch, logger, endpoint, key, params, send, raw);
  };

  var getOrganisations = function getOrganisations(params) {
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return queryOrganisationApi(fetch, logger, endpoint, key, params, send, raw);
  };

  var getOrganisationsMetadata = function getOrganisationsMetadata(stepSize, orgIds) {
    return queryOrganisationMetadataApi(fetch, logger, endpoint, key, send, stepSize, orgIds);
  };

  var getAgentMetadata = function getAgentMetadata(agentId, orgIds, allTrans) {
    return queryAgentMetadataApi(fetch, logger, endpoint, key, send, agentId, orgIds, allTrans);
  };

  return {
    getListings,
    getSuburbs,
    getMembers,
    getOrganisations,
    getOrganisationsMetadata,
    getAgentMetadata
  };
};
/**
 * Load large result sets sequentially using ES's `after`; the random access
 * from+size method doesn't work over 10k results.
 */


function loadLargeSet(_x36, _x37) {
  return _loadLargeSet.apply(this, arguments);
}

function _loadLargeSet() {
  _loadLargeSet = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(api, params) {
    var size,
        _params,
        results,
        totalResults,
        _context15,
        next,
        _args6 = arguments;

    return _regenerator.default.wrap(function _callee6$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            size = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : 10000;
            _params = _objectSpread(_objectSpread({}, params), {}, {
              size
            });
            _context16.next = 4;
            return api(_params);

          case 4:
            results = _context16.sent;
            totalResults = results.totalResults; // Load pages sequentially, merging them on to the final result set

          case 6:
            if (!(results.results.length < totalResults)) {
              _context16.next = 14;
              break;
            }

            _context16.next = 9;
            return api(_objectSpread(_objectSpread({}, _params), {}, {
              after: results.nextPageAfter
            }));

          case 9:
            next = _context16.sent;
            results.results = (0, _concat.default)(_context15 = []).call(_context15, (0, _toConsumableArray2.default)(results.results), (0, _toConsumableArray2.default)(next.results));
            results.nextPageAfter = next.nextPageAfter;
            _context16.next = 6;
            break;

          case 14:
            return _context16.abrupt("return", results);

          case 15:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee6);
  }));
  return _loadLargeSet.apply(this, arguments);
}

var _default = getClient;
exports.default = _default;